import { axiosInstance } from "../../../axios/axiosInstance";
import { LANDING_API_URL, getDefaultHeaders } from "../../../config";

const authHeaders = (extra = {}) => {
  const authToken = localStorage.getItem("authToken");
  return {
    ...getDefaultHeaders(),
    Authorization: `Bearer ${authToken}`,
    ...extra,
  };
};

export const getCertificates = () =>
  axiosInstance.get(`${LANDING_API_URL}/certificates`, {
    headers: authHeaders(),
  });

export const createCertificateRequest = (formData) =>
  axiosInstance.post(`${LANDING_API_URL}/certificates`, formData, {
    headers: authHeaders({ "Content-Type": "multipart/form-data" }),
  });

export const updateCertificateRequest = (certificateId, formData) =>
  axiosInstance.post(
    `${LANDING_API_URL}/certificates/${certificateId}`,
    formData,
    {
      headers: authHeaders({ "Content-Type": "multipart/form-data" }),
    },
  );

export const removeCertificate = (certificateId) =>
  axiosInstance.delete(`${LANDING_API_URL}/certificates/${certificateId}`, {
    headers: authHeaders(),
  });
